import { useState } from 'react';
import { showSuccess } from '../../0_presentation/core/components/feedback/snackbar';
import IContactRepository from '../../2_domain/intro/iContactRepository';
import { Message } from '../../2_domain/intro/intro';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const useContactController = () => {
  const contactRepo = Get.find<IContactRepository>('IContactRepository');

  const [name, setName] = useState<Name>('');
  const [email, setEmail] = useState<Email>('');
  const [phone, setPhone] = useState<Phone>('');
  const [message, setMessage] = useState<Message>('');

  const [loading, setLoading] = useState<boolean>(false);

  const resetForm = () => {
    setName('');
    setEmail('');
    setPhone('');
    setMessage('');
  };

  const onSendMessage = () => {
    if (name === '' || email === '' || phone === '' || message === '') return;
    promiseResolver({
      promise: contactRepo.sendContactSlx({
        name,
        email,
        phone,
        message,
      }),
      isLoadingCallback: setLoading,
      successCallback: () => {
        resetForm();
        showSuccess('Message sent successfully');
      },
    });
  };

  return {
    name,
    setName,
    email,
    setEmail,
    phone,
    setPhone,
    message,
    setMessage,
    onSendMessage,
    loading,
  };
};

export default useContactController;
